<template>
  <v-container class="mx-8 ma-sm-12" fluid>
    <div class="text-h5 font-weight-black _light_grey--text">{{ $t('customerService') }}</div>
    <v-row class="mt-1 mt-sm-3 mx-auto" justify="end"><v-btn class="_blue _light_grey--text" @click="track()">{{$t('track')}}</v-btn></v-row>
    <v-card class="my-4 my-sm-12 mx-auto" color="_light_grey">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="mail.replyMailbox" :label="$t('replyMailbox')" :rules="rules" required></v-text-field>
          <v-select :items="serviceItem" v-model="mail.service" :label="$t('serviceType')" item-text="label" item-value="value" :rules="rules" required></v-select>
          <template v-if="!isReturnRequest">
            <v-select :items="categoryItem" v-model="mail.category" :label="$t('questionType')" item-text="label" item-value="value" :rules="rules" required></v-select>
            <v-text-field v-model="mail.subject" :label="$t('mailSubject')" :rules="rules" required></v-text-field>
          </template>
          <template v-else>
            <v-select :items="deviceItem" v-model="mail.deviceId" :label="$t('deviceName')" item-text="label" item-value="value" :rules="rules" required></v-select>
            <v-select :items="appItem" v-model="mail.appId" :label="$t('application')" item-text="label" item-value="value" :rules="rules" :hint="appHint" required :suffix="appHint"></v-select>
          </template>
        </v-form>
        <div>{{ isReturnRequest ? $t('mailReason') : $t('mailContent') }}</div>
        <div class="mb-8"><quillEditor style="height: 300px; font-size: 20px" v-model="mail.question" :options="editorOption" /></div>
        <!-- <div class="my-2">{{ $t('attachPic') }}</div> -->
        <!-- <div class="mb-8"><quillEditor style="width: 200px" v-model="attachPic" :options="imageOption" /></div> -->
        <v-file-input v-model="attachPic" chips multiple accept="image/*" :label="$t('attachPic')"></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="$router.go(-1)">{{ $t('back') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="confirmSend()">{{ $t('submit') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showReturnDialog" max-width="800">
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="_blue" dark dense>{{$t('track')}}</v-toolbar>
          <v-card-text class="mt-3">
            <v-simple-table dense fixed-header height="300px" >
              <template v-slot:default>
                <thead><tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">{{$t('deviceName')}}</th>
                  <th class="text-left">{{$t('application')}}</th>
                  <th class="text-left">{{$t('refundStatus')}}</th>
                </tr></thead>
                <tbody>
                  <tr v-for="item in returnList" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.deviceName }}</td>
                    <td>{{ item.appName }}</td>
                    <td>{{ item.refundStatusName }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="dialog.value = false" color="_blue" class="white--text">{{$t('close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <Dialog :isShow="confirmDialog" :title="dialogText" msg="confirmMsg" :verbMsg="dialogText" @confirm="sendMail()" @cancel="confirmDialog = false" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import 'quill/dist/quill.core.css'; // import styles
import 'quill/dist/quill.snow.css'; // for snow theme
import 'quill/dist/quill.bubble.css'; // for bubble theme
// import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';
// import ImageResize from 'quill-image-resize';
import Db from '@/api/awsDb';
import S3 from '@/api/awsS3';
import Mail from '../store/mail';
import Dialog from '../components/Dialog.vue';
import Product from '../store/product';

// Quill.register('modules/imageResize', ImageResize);

export default {
  name: 'CustomerService',
  data: () => ({
    mail: {
      replyMailbox: '',
      question: '',
    },
    editorOption: {
      modules: { toolbar: false },
      formats: ['background', 'bold', 'color', 'font', 'code', 'italic', 'link', 'size', 'strike', 'script', 'underline', 'blockquote', 'header', 'indent', 'list', 'align', 'direction', 'code-block', 'formula'],
    },
    // imageOption: {
    //   modules: {
    //     toolbar: { container: [['image']] },
    //     imageResize: {
    //       displaySize: true,
    //       displayStyles: { backgroundColor: 'black', border: 'none', color: 'white' },
    //       modules: ['Resize', 'DisplaySize', 'Toolbar'],
    //     },
    //   },
    // },
    attachPic: [],
    deviceItem: [],
    returnList: [],
    unsolvedList: [],
    showReturnDialog: false,
    confirmDialog: false,
    dialogText: 'submit',
    isUpdate: false,
  }),
  components: { quillEditor, Dialog },
  mounted() {
    this.initTooltips();
    this.initData();
  },
  beforeUpdate() {
    if (this.userAttribute.email && !this.isUpdate) {
      this.initData();
      this.isUpdate = true;
    }
  },
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapGetters('dbTable', ['productList', 'permissionId']),
    ...mapGetters('locale', ['locale']),
    isReturnRequest() {
      return this.mail.service === 'returnRequest';
    },
    serviceItem() {
      const ary = ['advisory'];
      if (this.isSignIn) {
        ary.push('returnRequest');
      }
      return ary.map((x) => ({ label: this.$t(x), value: x }));
    },
    categoryItem() {
      const ary = ['Account', 'Bill', 'Refund', 'Discount', 'AppUsage', 'Platform', 'Industry'];
      if (this.isPermit('launch')) {
        ary.push('Launch');
        ary.push('Income');
      }
      if (this.isPermit('audit') || this.isPermit('launch')) ary.push('Audit');
      if (this.isPermit('shopInShop')) {
        ary.push('ShopInShop');
        ary.push('Publisher');
      }
      if (this.isPermit('download')) ary.push('Other');
      return ary.map((x) => ({ label: this.$t(`qa${x}`), value: x }));
    },
    appItem() {
      const ary = [];
      if (!this.mail.deviceId) return ary;
      const list = Object.keys(this.userAttribute.ownApp[this.mail.deviceId]);
      list.forEach((element) => {
        const isReturn = this.unsolvedList.findIndex((x) => x.deviceId === this.mail.deviceId && x.appId === element);
        // console.log(isReturn);
        if (isReturn === -1) {
          const index = this.productList.find((x) => x.id === element);
          if (index !== undefined) ary.push({ label: index.name, value: index.id });
        }
      });
      return ary;
    },
    purchaseTime() {
      if (!this.mail.deviceId || !this.mail.appId) return '';
      return this.userAttribute.ownApp[this.mail.deviceId][this.mail.appId];
    },
    appHint() {
      if (!this.mail.appId) return '';
      if (new Date(this.purchaseTime).toDateString() === 'Invalid Date') return this.$t('invalid');
      let showContent = 'errProbation';
      if (this.isProbation()) {
        showContent = 'allowReturn';
      } else if (this.isSubscribe()) {
        showContent = 'allowUnsubscribe';
      } else {
        showContent = 'errProbation';
      }
      return `${this.$t('purchaseDate')}：${new Date(this.purchaseTime).toDateString()} (${this.$t(showContent)})`;
    },
    rules() {
      return [(v) => !!v || this.$t('require')];
    },
  },
  methods: {
    isPermit(permission) {
      if (!this.isSignIn) return false;
      if (!Object.keys(this.userAttribute).length) return false;
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId(permission)) !== -1;
    },
    isSubscribe() {
      if (!this.mail.appId) return false;
      const appInfo = this.productList.find((x) => x.id === this.mail.appId);
      return appInfo.chargeTypeId === '1';
    },
    isProbation() {
      const probation = new Date();
      probation.setDate(probation.getDate() - 15);
      probation.setHours(0, 0, 0, 0);
      console.log(probation.toLocaleString());
      console.log(new Date(this.purchaseTime).toLocaleString());
      if (this.purchaseTime < probation.getTime()) {
        return false;
      }
      return true;
    },
    confirmSend() {
      if (!this.$refs.form.validate()) return;
      this.dialogText = 'submit';
      if (this.isReturnRequest) {
        if (!this.isProbation()) {
          if (!this.isSubscribe()) {
            this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errProbation')] });
            return;
          }
          this.dialogText = 'unsubscribe';
        }
      }
      this.confirmDialog = true;
    },
    sendMail() {
      this.confirmDialog = false;
      const sendMail = { ...this.mail };
      sendMail.id = new Date().getTime();
      sendMail.status = 'unsolved';
      sendMail.email = this.userAttribute.email;
      sendMail.log = [];
      // sendMail.question += `<br>${this.attachPic}`;

      this.attachPic.forEach((x) => {
        // console.log(x);
        S3.upload(`public/support/${sendMail.id}/Q_${x.name}`, x);
        sendMail.question += `<br><a href="${process.env.VUE_APP_S3_URL}public/support/${sendMail.id}/Q_${x.name}">${x.name}</a>`;
      });

      if (this.isReturnRequest && !this.isProbation() && this.isSubscribe()) {
        const params = { email: this.userAttribute.email, appId: this.mail.appId, deviceId: this.mail.deviceId };
        params.appName = this.appItem.find((x) => x.value === this.mail.appId).label;
        this.$store.commit('loading/start', { text: 'working' });
        Product.uninstall(params).then((x) => {
          console.log(x);
          this.$store.commit('loading/stop');
          this.$store.commit('authenticate/setUserAttribute', x.data.userInfo);
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('unsubscribe'), ' ', this.$t('success')] });
        }).catch(() => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('unsubscribe'), ' ', this.$t('fail')] });
        });
        sendMail.status = 'unsubscribe';
        sendMail.log.push({ responseTime: sendMail.id, responder: 'auto-reply', action: 'unsubscribe' });
        this.unsubscribeAutoReply(sendMail);
        this.mail = { replyMailbox: this.userAttribute.email, question: '' };
      } else {
        this.sendAutoReply(sendMail);
      }
      this.attachPic = [];
      // this.mail.attachPic = [`public/support/${this.mail.id}.jpg`];

      // this.mail.attachPic.forEach((x) => {
      //   S3.upload(x, this.attachPic);
      // });
      this.$store.commit('loading/start', { text: 'working' });
      Db.create('support', sendMail)
        .then((res) => {
          console.log(res);
          this.updateSupport();
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('submit'), ' ', this.$t('success')] });
        })
        .catch((error) => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
        });
    },
    unsubscribeAutoReply(sendMail) {
      const option = {
        toAddr: [this.mail.replyMailbox],
        id: sendMail.id,
        service: 'unsubscribe',
        appName: this.appItem.find((x) => x.value === this.mail.appId).label,
        deviceName: this.deviceItem.find((x) => x.value === sendMail.deviceId).label,
        locale: this.locale,
      };
      console.log(option);
      this.$store.commit('loading/start');
      Mail.serviceAutoReply({ mail: option }).then(() => {
        this.$store.commit('loading/stop');
        this.mail = { replyMailbox: this.userAttribute.email, question: '' };
      });
    },
    sendAutoReply(sendMail) {
      // console.log(sendMail);
      const params = {
        toAddr: [this.mail.replyMailbox],
        id: sendMail.id,
        type: sendMail.category,
        category: this.$t(`qa${sendMail.category}`),
        service: sendMail.service,
        subject: sendMail.subject,
        locale: this.locale,
      };
      if (this.isReturnRequest) {
        params.appName = this.appItem.find((x) => x.value === this.mail.appId).label;
        params.deviceName = this.deviceItem.find((x) => x.value === this.mail.deviceId).label;
        params.category = this.$t(`${sendMail.service}`);
        params.content = `${this.$t('mailReason')}：${sendMail.question}`;
      } else {
        params.content = `${this.$t('mailContent')}：${sendMail.question}`;
      }
      console.log(params);
      this.$store.commit('loading/start');
      Mail.serviceAutoReply({ mail: params }).then(() => {
        this.$store.commit('loading/stop');
        this.mail = { replyMailbox: this.userAttribute.email, question: '' };
      });
    },
    track() {
      this.showReturnDialog = true;
      this.returnList = [];
      if (!this.userAttribute.email) return;
      Db.query('support', { email: this.userAttribute.email }, { service: 'returnRequest' }).then((result) => {
        let value = {};
        result.data.forEach((element) => {
          value = { ...element };
          const temp = this.productList.find((x) => x.id === element.appId);
          value.appName = temp.name;
          value.deviceName = this.deviceItem.find((x) => x.value === element.deviceId).label;
          if (element.status === 'unsolved') {
            value.refundStatusName = this.$t('pending');
          } else if (element.status === 'unreturned') {
            value.refundStatusName = this.$t('noRefund');
          } else if (element.status === 'returning' || element.status === 'returned') {
            let statusName = '0';
            switch (element.refundStatus) {
              default:
              case '0': statusName = this.$t('pending'); break; // 未退款
              case '1': statusName = this.$t('refundProcessing'); break; // 退款處理中
              case '2': statusName = this.$t('refundComplete'); statusName += `(${element.refundId})`; break; // 退款完成
              case '3':
              case '4':
              case '5': statusName = this.$t('cancelDeal'); statusName += `(${element.refundStatus})`; break; // 取消交易
              case '99': statusName = this.$t('refundException'); break; // 退款異常
              case '98': statusName = this.$t('systemException'); break;
            }
            console.log(statusName);
            value.refundStatusName = statusName;
          }
          this.returnList.push(value);
        });
      });
    },
    async updateSupport() {
      this.unsolvedList = await Db.scan('support', { email: this.userAttribute.email, service: 'returnRequest', status: 'unsolved' }, ['deviceId', 'appId']);
      // console.log(this.unsolvedList);
    },
    initData() {
      // this.$store.commit('loading/start', { text: 'working' });
      this.updateSupport();
      Db.scan('install', { email: this.userAttribute.email }, ['createTime', 'deviceId', 'deviceName']).then((result) => {
        result.sort((a, b) => b.createTime - a.createTime);
        if (this.userAttribute.ownApp) {
          Object.keys(this.userAttribute.ownApp).forEach((x) => {
            const temp = result.find((y) => y.deviceId === x);
            this.deviceItem.push({ label: temp.deviceName, value: x });
          });
        }
        // this.$store.commit('loading/stop');
      }).catch(() => {
        // this.$store.commit('loading/stop');
        // this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
      });
      this.mail.replyMailbox = this.userAttribute.email;
    },
    initTooltips() {
      // const titleConfig = [{ Choice: '.ql-image', title: this.$t('insertImage') }];
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = this.$t('hintContent') + this.$t('insertImage');
      // document.getElementsByClassName('ql-editor')[1].dataset.placeholder = this.$t('insertImage');
      // titleConfig.forEach((item) => {
      //   const tip = document.querySelector(`.quill-editor ${item.Choice}`);
      //   if (tip) tip.setAttribute('title', item.title);
      // });
    },
  },
};
</script>

<style>
.ql-container {
  font-size: 16px;
}
</style>
